import {Component, Input} from '@angular/core';
import {ContentSwitcherNavigationInput} from '../../custom-components/navigation-helper-prototype/content-switcher-navigation-input.interface';
import {NavigationHelperPrototypeService} from '../../custom-components/navigation-helper-prototype/navigation-helper-prototype.service';

@Component({
  selector: 'vdw-invalid-form-message',
  templateUrl: './invalid-form-message.component.html',
  styleUrls: ['./invalid-form-message.component.scss']
})
export class InvalidFormMessageComponent {
  @Input() public message = 'ANGULAR_COMPONENT_LIBRARY.FORM_MESSAGE.CHECK_INVALID_FIELDS';
  @Input() public compact = false;
  @Input() public link = null;
  @Input() public linkTranslationKey = 'GENERAL.ACTIONS.LOAD';
  @Input() public loadEntry: ContentSwitcherNavigationInput;

  public entityName = '';

  public constructor(private readonly navigationHelper: NavigationHelperPrototypeService) {}

  protected navigate(): void {
    this.navigationHelper.navigateWithContentSwitcher(this.loadEntry);
  }

  protected isDialog(): boolean {
    return this.navigationHelper.contentSwitcherDialogActive();
  }
}
